import createManager from 'kandy-logger'

const manager = createManager({ level: 'DEBUG' })
export const logManager = manager
